import { Tag } from 'antd';
import { PPA_SCENARIO_STATUS_COLOR_MAPPING, formatPpaStatusLabel } from 'utils/ppaHelpers';
import { PpaTableRowType } from 'types/ppa';
import type { InternalTableRecord } from '../types';

const StatusCell = ({ record }: { record: InternalTableRecord }) => {
    if (record.row_type === PpaTableRowType.Project) {
        return null;
    }
    const status = record.status || 'draft';
    return (
        <Tag
            color={PPA_SCENARIO_STATUS_COLOR_MAPPING[status] ?? 'default'}
            className="!m-0 !text-[12px] !leading-[20px] !px-2 !rounded-[4px] capitalize"
        >
            {formatPpaStatusLabel(status)}
        </Tag>
    );
};

export default StatusCell;
